// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/styles/style.scss
// module id = 6
// module chunks = 0